import React from 'react';
import { DatePicker } from 'antd';

const ReusableDatePicker = ({ label, onChange, format = "YYYY-MM-DD", disabled = false, ...props }) => {
  return (
    <div className="reusable-date-picker">
      {label && (
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
          {label}
        </label>
      )}
      <DatePicker
        style={{ width: '100%' }}
        label={label}
        onChange={onChange}
        format={format}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

export default ReusableDatePicker;
